import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'
import { LayoutFullComponent } from './layout/layout-full/layout-full.component'
import { AuthLayoutComponent } from './layout/auth-layout/auth-layout.component'
import { VtSsoValidateTicketComponent } from './layout/vt-sso-validate-ticket.component'
import { VtSSOAuthGuardService } from 'projects/vss-ui/src/vss-ui/services/auth/vt-sso-auth-guard.service'
import { HomeComponent } from './modules/home/component/home.component'
import { UserResolver } from 'projects/vss-ui/src/vss-ui/services/auth/user-info.resolver'
import { RoleGuard } from 'projects/vss-ui/src/vss-ui/modules/permission/role.guard'

const routes: Routes = [
  { path: '', redirectTo: '/home', pathMatch: 'full' },
  {
    path: 'home',
    canActivate: [VtSSOAuthGuardService, RoleGuard],
    resolve: { ruleData: UserResolver },
    component: HomeComponent
  },
  { path: 'validate-ticket', pathMatch: 'full', component: VtSsoValidateTicketComponent },
  {
    path: '',
    canActivate: [VtSSOAuthGuardService, RoleGuard],
    resolve: { ruleData: UserResolver },
    component: LayoutFullComponent,
    children: [
      {
        path: 'user',
        loadChildren: () => import('./modules/user/user.module').then(m => m.UserModule),
        data: { roles: [], breadcrumb: 'MENU.HUMAN_RESOURCE_MANAGEMENT' }
      },
      // {
      //   path: 'admin',
      //   loadChildren: () => import('./modules/admin/admin.module').then(m => m.AdminModule),
      //   data: { roles: [], breadcrumb: '' }
      // },
      {
        path: 'dashboard',
        loadChildren: () => import('./modules/dashboard/dashboard.module').then(m => m.DashboardModule),
        data: { roles: [], breadcrumb: 'Dashboard' }
      },
      {
        path: 'category-management',
        loadChildren: () => import('./modules/category/category.module').then(m => m.CategoryModule),
        data: { roles: [], breadcrumb: 'MENU.CATEGORY_MANAGEMENT' }
      },
      {
        path: 'admin-management',
        loadChildren: () => import('./modules/admin-management/admin-management.module').then(m => m.AdminManagementModule),
        data: { roles: [], breadcrumb: 'MENU.SYSTEM_MANAGEMENT' }
      },
      {
        path: 'training',
        loadChildren: () => import('./modules/training/training.module').then(m => m.TrainingModule),
        data: { roles: [], breadcrumb: 'MENU.TRAINING_MANAGEMENT' }
      },
      {
        path: 'healthcare',
        loadChildren: () => import('./modules/healthcare/healthcare.module').then(m => m.HealthcareModule),
        data: { roles: [], breadcrumb: 'MENU.HEALTH_MANAGEMENT' }
      },
      {
        path: 'competition',
        loadChildren: () => import('./modules/competition/competition.module').then(m => m.CompetitionModule),
        data: { roles: [], breadcrumb: 'MENU.COMPETITION_MANAGEMENT' }
      },
      {
        path: 'reward',
        loadChildren: () => import('./modules/reward/reward.module').then(m => m.RewardModule),
        data: { roles: [], breadcrumb: 'MENU.REWARD_MANAGEMENT' }
      },
    ]
  },
  {
    path: 'auth',
    component: AuthLayoutComponent,
    loadChildren: () =>
      import('./modules/auth/auth.module').then((m) => m.AuthModule)
  },
  {
    path: 'error',
    loadChildren: () => import('./modules/error-layout/error-layout.module').then(m => m.ErrorLayoutModule),
  },
  {
    path: '**',
    redirectTo: '/home',
    pathMatch: 'full',
    canActivate: [VtSSOAuthGuardService, RoleGuard],
    resolve: { ruleData: UserResolver },
  }
]

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
